import React, { createContext, useContext } from "react";

export const MonetateContext = createContext({});

export function MonetateProvider({ experiences, children }) {
  return <MonetateContext.Provider value={{ experiences }}>{children}</MonetateContext.Provider>;
}

export const findExperience = (experiences, name) =>
  experiences ? experiences.find(item => item.experienceName.includes(name)) : null;

export const useExperience = name => {
  const { experiences } = useContext(MonetateContext);
  return findExperience(experiences, name);
};

// This function extracts and decodes the Monetate experiences from the request headers.
// It is used in getServerSideProps of pages to pass the experiences to the MonetateProvider.
export const extractExperiences = req => {
  // In the "stubs" environment, we return a predefined set of experiences for testing purposes.
  let experiences = process.env.NEXT_PUBLIC_ENVIRONMENT_NAME === "stubs" ? devExperiences : [];

  // In a production environment, we expect the experiences to be passed in the "x-experiences-json" header.
  if (req?.headers["x-experiences-json"]) {
    try {
      experiences = JSON.parse(Buffer.from(req.headers["x-experiences-json"], "base64").toString("utf-8"));
    } catch (err) {
      console.error("Failed parsing x-experiences-json", err);
    }
  }
  return experiences; // Return the extracted experiences, or an empty array if none are found or if parsing fails.
};

const devExperiences = [
  {
    impressionId: null,
    experienceName: "GH | AB-4279 | Streamline JL giftcard hero section",
    variantLabel: "Experiment",
    parameters: { feature: "experiment" },
  },
  {
    impressionId: null,
    experienceName: "AS | AB-5105 | Carrier tracking banner",
    variantLabel: "Experiment",
    parameters: { feature: "experiment" },
  },
  {
    impressionId: null,
    experienceName: "AS | AB-5184 | xmas banner",
    variantLabel: "Experiment",
    parameters: { feature: "experiment" },
  },
  {
    impressionId: "3.MjU0MjQwMi4xLjE3NTIyMzQyMjkuMjM4NjYx",
    experienceId: 2024971,
    experienceName: "RD | AB-5812 | Customer & Account | Returns & Refunds | Agentforce chat button visibility",
    variantLabel: "Experiment",
    parameters: {},
  },
  {
    impressionId: "3.MjU0MjQwjljgG43l454uwZXSMjkuMjM4NjYx",
    experienceId: 2052459,
    experienceName: "RD | AB-6553 | Customer & Account | Live Chat Prominence Experience - 2A",
    variantLabel: "Experiment",
    parameters: {},
  },
];

export const MONETATE_EVENT_NAMES = {
  AB5184ShopGiftCardsClicked: "AB-5184-ShopGiftCardsClicked",
  AB5184FindOutHowClicked: "AB-5184-FindOutHowClicked",
  AB6017ContactRevealed: "AB-6017-failure-contact-reveal",
  AB6017ContactUsDetailsRevealed: "contact_us_details_retrieved",
  AB6553EmailFormSubmitted: "email_form_submitted",
  AB6553LiveChatEngagementRate: "live_chat_engagement_rate",
};

export const trackMonetateEvent = eventKey => {
  if (!eventKey) {
    console.warn("Monetate eventKey is required");
    return;
  }
  window.monetateQ = window.monetateQ || [];
  window.monetateQ.push(["trackEvent", [eventKey]]);
};
